import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import { Badge } from '../Badge';

/**
 * Primary UI component for user interaction
 */
export const BadgeGroup = ({ options, value, onChange, isClickable, selected }) => {
    const [selectedValue, setSelectedValue] = useState(selected);

    useEffect(() => {
        if (value) {
            setSelectedValue(value);
        }
    }, [value]);

    // const handleChange = (selectedValue) => {
    //     let newValues = [];
    //     const isSelected = selectedValue.includes(selectedValue);
    //     if (isSelected) {
    //         newValues = selectedValue.filter((value) => value !== selectedValue);
    //     } else {
    //         newValues = [...selectedValue, selectedValue];
    //     }
    //     setSelectedValue(newValues);
    //     onChange(newValues);
    // };

    const handleChange = (selectedValue) => {
        setSelectedValue(selectedValue);
        onChange(selectedValue);
    };

    const isSelected = (value) => selectedValue === value;

    return (
        <div className="grid gap-4 grid-cols-2 w-full">
            {options.map((child, idx) => (
                <Badge
                    key={idx}
                    text={child.label}
                    onChange={handleChange}
                    isClickable={isClickable}
                    checked={isSelected(child.value)}
                    {...child}
                />
            ))}
        </div>
    );
};

BadgeGroup.propTypes = {
    /**
     * Add your buttons here
     */
    options: PropTypes.arrayOf(PropTypes.object).isRequired,

    /**
     * on value Change event
     */
    onChange: PropTypes.func,

    wrapperClass: PropTypes.string,

    /**
     * Is this a radio group or a checkbox group
     */
    type: PropTypes.oneOf(['radio', 'checkbox']),

    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),

    isClickable: PropTypes.bool,
};

BadgeGroup.defaultProps = {
    isClickable: false,
};
